/**
 * Funkcije i samo funkcije
 */

function close_alert(close) {
    $(close).parents('div.alert').slideUp(300);
}



function htmlEscape(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}


/*
 Za šerovanje - popup umesto novog taba
 */
function shareFB(url) {
    window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
        'facebook-share-dialog',
        'width=626,height=436');
}
function shareTW(text, url) {
    window.open(
        'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + ';text=' + text + ';size=l&amp;count=none',
        'twitter-share-dialog',
        'width=626,height=436');
}

// Slanje aktivacionog linka...
function sendActivationEmail(el) {

    $(el).after('<em class="sendingActivationEmail">Šalje se...</em>');

    $(el).remove();

    $.post('/posalji-aktivacioni-mail', {}, function (response) {
        var new_el = $('body em.sendingActivationEmail');
        if (response == 1) {
            new_el.text('Poslato.')
        }
    })
}

function promocode_generator()
{
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    for( var i=0; i < 7; i++ )
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}